import React, { useState, useEffect } from 'react'
import { SectionProfile } from './SectionProfile/index'
import { Text } from '../../constants/TextConstants'
import { emptyProfile } from '../ViewProfile/emptyProfile'
import { Tags } from './Tags'
import { InfoBox } from './InfoBox'
import {
  sortByStartedDate,
  removeSkillByIndex,
  tagsMapper,
  useNavigateToWhenOwnView,
  formatPercentage
} from '../../utils/utils'
import {
  RowHeader,
  Wrapper,
  ProfileWrapper,
  SubmitWrapper,
  Button,
  BubbleButton,
  MailIcon,
  EditTitle,
  ContainerLinks,
  SaveButtonWrapper
} from './styles'
import { ModalSummary } from './Modals/Summary'
import { ModalExperience } from './Modals/Experience'
import { message } from 'antd'
import 'antd/dist/antd.css'
import { ModalLanguages } from './Modals/Languages'
import { ModalEducationalBackground } from './Modals/Qualifications'
import { Name, TitleName } from './Modals/styles'
import { EmptyDiv, ErrorText } from './Inputs/styles'
import { epagAPI } from '../../API/epagAPI'
import HeaderLinks from './../HeaderLinks'
import {
  DBSkills,
  FrameworksAndTechnologies,
  programmingLanguages,
  SoftSkills,
  TechnicalSkills,
  Hobbies,
  EducationGrades,
  CertificationEntity,
  backgroundDocument,
  Domains,
  IndustrySector,
  LanguagesSkills,
  TEMPLATE_SECTIONS_THRESHOLD
} from '../../constants/constants'
import { useInputValue } from '../../hooks/useInputValue'
import { useNavigate, useParams } from 'react-router-dom'
import { useGetToken } from '../../hooks/useGetToken'
import { useRenewToken } from '../../hooks/useRenewToken'
import PropTypes from 'prop-types'
import { HeaderMenu } from '../HeaderMenu'
import { Disclaimer } from '../Disclaimer'
import { Spinner } from '../Spinner'
import { useSave } from '../../Context/saveContext'
import { UserDefinedSkill, SkillLevelModal } from '../Modals/GenericModals'
import BeforeUnloadHandler from '../BeforeUnloadHandler/BeforeUnloadHandler'
import { TitleWithTooltipAboutAddingSkills } from './Modals/TitleWithToolTip'
import RepositoryModal from '../Modals/GenericModals/RepositoryModal'
import { PERMISSION_CODES } from '../../constants/permissions'

export const EditProfile = ({ hideEditButton = false, hideHeaderMenu = true }) => {
  const { userId } = useParams()
  const [modelProfile, setModelProfile] = useState(emptyProfile)
  const [summaryModal, setSummaryModal] = useState(false)
  const [createModal, setCreateModal] = useState(false)
  const [languagesModal, setLanguagesModal] = useState(false)
  const [ProgrammingSkillsModal, setProgrammingSkillsModal] = useState(false)
  const [DBSkillsModal, setDBSkillsModal] = useState(false)
  const [DomainSkillsModal, setDomainSkillsModal] = useState(false)
  const [frameworksModal, setFrameworksModal] = useState(false)
  const [softSkillsModal, setSoftSkillsModal] = useState(false)
  const [repositoryModal, setRepositoryModal] = useState(false)
  const [technicalSkillsModal, setTechnicalSkillsModal] = useState(false)
  const [hobbiesModal, setHobbiesModal] = useState(false)
  const [educationalBackGroundsModal, setEducationalBackGroundsModal] = useState(false)
  const [selectedEducationalBackGroundTag, setSelectedEducationalBackGroundTag] = useState()
  const [certificationsModal, setCertificationsModal] = useState(false)
  const [selectedCertificationTag, setSelectedCertificationTag] = useState()
  const [isWaitingSave, setIsWaitingSave] = useState(false)
  const [Email, setEmail] = useState('')
  const ErrorRequest = useInputValue(false)
  const { token } = useGetToken()
  const { renewToken } = useRenewToken()
  const [ErrorFetch, setErrorFetch] = useState('')
  const [firstModelInRender, setFirstModelInRender] = useState(null)
  const { setIsSaved, setProfileEmail, isSaved, userProfile, setUserProfile, userPermissions, permissionsQuantity } =
    useSave()
  const navigate = useNavigate()
  const isOwnProfile = !userId
  const [canSelectOnePage, setCanSelectOnePage] = useState(true)
  useNavigateToWhenOwnView(userId, '/edit')

  const alertUser = (e) => {
    if (!isSaved) {
      e.preventDefault()
      e.returnValue = ''
    }
  }

  const handleSaveStateChange = (newIsSaved) => {
    setIsSaved(newIsSaved)
  }

  const handleOnePageQuantity = () => {
    if (modelProfile.professional_experience.length > 0) {
      const isOnePageItems = modelProfile.professional_experience.filter((experience) => experience.is_one_page)
      setCanSelectOnePage(isOnePageItems.length < 5)
    }
  }

  useEffect(() => {
    window.addEventListener('beforeunload', alertUser)
    return () => {
      window.removeEventListener('beforeunload', alertUser)
    }
  }, [alertUser])

  useEffect(() => {
    if (firstModelInRender !== null) {
      const compareModels = JSON.stringify(modelProfile) === JSON.stringify(firstModelInRender)
      if (!compareModels) {
        localStorage.setItem('local-profile', JSON.stringify(modelProfile))
        setIsSaved(false)
      } else {
        localStorage.removeItem('local-profile')
        setIsSaved(true)
      }
    }
    handleOnePageQuantity()
  }, [modelProfile])

  useEffect(() => {
    const localProfile = localStorage.getItem('local-profile')
    if (token && userProfile) {
      if (isOwnProfile) {
        setFirstModelInRender(userProfile)
        setModelProfile(userProfile)
        setEmail(userProfile.email)
        setProfileEmail(userProfile.email)
        localStorage.removeItem('local-profile')
      } else {
        if (!userPermissions.includes(PERMISSION_CODES.editProfile.code)) {
          navigate('/404')
        } else {
          setEmail(`${userId}@endava.com`)
          setProfileEmail(`${userId}@endava.com`)
          epagAPI
            .GetUsersProfile(`${userId}@endava.com`, token)
            .then((answer) => {
              if (answer.code === 403) {
                navigate('/404')
              }
              setFirstModelInRender(answer)
              setModelProfile(answer)
              setErrorFetch('')
              localStorage.removeItem('local-profile')
            })
            .catch((error) => {
              setErrorFetch(error.message)
              console.error('error', ErrorFetch)
              navigate('/Forbidden', { replace: true })
            })
        }
      }
    }
    if (localProfile && localProfile.email === modelProfile.email) {
      setModelProfile(JSON.parse(localProfile))
    }
  }, [token, userProfile, userId, permissionsQuantity])

  const dataModel = {
    project_rol: '',
    company: '',
    started_date: '',
    ended_date: '',
    description: '',
    responsabilities: '',
    programming_languages: [],
    technologies_and_frameworks: [],
    testing_and_development_tools: [],
    additional_info_title: '',
    additional_info_desc: '',
    is_one_page: false
  }

  const skillsEnum = {
    languages: 'languages',
    educationalBackground: 'educational_background',
    certification: 'certification',
    programmingLanguages: 'programming_languages',
    databases: 'databases',
    domains: 'domains',
    technologiesAndFrameworks: 'technologies_and_frameworks',
    softSkills: 'soft_skills',
    technicalSkills: 'technical_skills',
    hobbies: 'hobbies'
  }

  const removeSkillFromModelByIndex = (index, skill) => {
    removeSkillByIndex(index, skill, setModelProfile)
  }

  const onSuccesfulSubmit = (profile) => {
    message.success(Text.SavedMessage, 4)
    setIsWaitingSave(false)
    ErrorRequest.setErrorText('')
    ErrorRequest.setError(false)
    setModelProfile(profile)
    setFirstModelInRender(profile)
    isOwnProfile && setUserProfile(profile)
    setIsSaved(true)
    localStorage.removeItem('local-profile')
  }

  const onWrongSubmit = (error) => {
    setIsWaitingSave(false)
    ErrorRequest.setErrorText(error.message)
    ErrorRequest.setError(true)
    localStorage.removeItem('local-profile')
  }

  // renews token
  const renewAndRequest = async (requestFunc) => {
    try {
      const updatedToken = await renewToken()
      if (updatedToken) {
        requestFunc(updatedToken)
      } else {
        console.error('The token could not be renewed')
      }
    } catch (error) {
      console.error('The token could not be renewed :', error.message)
    }
  }

  // this renews the token whether is expired or not; then submit the data with the newest token.
  const onSubmitWithRenew = async (profile) => {
    setIsWaitingSave(true)
    renewAndRequest(async (updatedToken) => {
      try {
        let profileRequest = await epagAPI.CreateProfile(profile, Email, updatedToken)
        if (profile.uploaded_image) {
          profileRequest = await epagAPI.CreateProfileImage(profile.uploaded_image, Email, updatedToken)
        }
        onSuccesfulSubmit(profileRequest)
      } catch (error) {
        onWrongSubmit(error)
      }
    })
  }
  return (
    <>
      <BeforeUnloadHandler shouldShowPrompt={!isSaved}>
        <>
          {!hideHeaderMenu && (
            <HeaderMenu mail={modelProfile.email} defaultNavName={Text.Edit} hideEditButton={hideEditButton} />
          )}
          <ProfileWrapper>
            {!isOwnProfile && (
              <>
                <EditTitle>Edit Profile</EditTitle>
                <ContainerLinks>
                  <HeaderLinks email={modelProfile.email} active='edit' />
                </ContainerLinks>
              </>
            )}
            {modelProfile.name.trim() !== '' ? (
              <RowHeader>
                <Name>
                  <TitleName>{Text.Name}</TitleName>
                  {`: ${modelProfile.name} ${modelProfile.lastName}`}
                </Name>
                <Disclaimer
                  icon={<BubbleButton size={20} />}
                  weight='bold'
                  left='5px'
                  text='The profile must be filled in English'
                />
                <Name>
                  <TitleName>{Text.Completion}:&nbsp;</TitleName>
                  {`${formatPercentage(modelProfile.profile_filling_percentage)}%`}
                </Name>
              </RowHeader>
            ) : (
              <EmptyDiv />
            )}
            <SectionProfile title={Text.SummaryAbout} pencil='true' ClickButton={() => setSummaryModal(true)}>
              {modelProfile.summary}
            </SectionProfile>

            <SectionProfile title={Text.SpokenLanguages} ClickButton={() => setLanguagesModal(true)}>
              <Tags
                background={backgroundDocument}
                data={tagsMapper(modelProfile.languages, skillsEnum.languages, skillsEnum)}
                template={skillsEnum.languages}
                removeItemFunc={(index) => removeSkillFromModelByIndex(index, skillsEnum.languages)}
                skillsEnum={skillsEnum}
                categoryName={LanguagesSkills}
                threshold={TEMPLATE_SECTIONS_THRESHOLD.languages}
                isDragDisable={true}
              />
            </SectionProfile>

            <SectionProfile
              title={Text.Education}
              ClickButton={() => {
                setSelectedEducationalBackGroundTag(null)
                setEducationalBackGroundsModal(true)
              }}>
              <Tags
                editableTag={true}
                onClick={(educationalBackground) => {
                  setSelectedEducationalBackGroundTag(educationalBackground)
                  setEducationalBackGroundsModal(true)
                }}
                background={backgroundDocument}
                data={tagsMapper(modelProfile.educational_background, skillsEnum.educationalBackground, skillsEnum)}
                removeItemFunc={(index) => removeSkillFromModelByIndex(index, skillsEnum.educationalBackground)}
                template={skillsEnum.educationalBackground}
                skillsEnum={skillsEnum}></Tags>
            </SectionProfile>

            <SectionProfile
              title={Text.Certifications}
              ClickButton={() => {
                setSelectedCertificationTag(null)
                setCertificationsModal(true)
              }}>
              <Tags
                editableTag={true}
                onClick={(certification) => {
                  setSelectedCertificationTag(certification)
                  setCertificationsModal(true)
                }}
                background={backgroundDocument}
                data={tagsMapper(modelProfile.certification, skillsEnum.certification, skillsEnum)}
                template={skillsEnum.certification}
                removeItemFunc={(index) => removeSkillFromModelByIndex(index, skillsEnum.certification)}
                skillsEnum={skillsEnum}></Tags>
            </SectionProfile>

            <SectionProfile title={Text.Experience} ClickButton={() => setCreateModal(true)}>
              <Wrapper>
                {sortByStartedDate(modelProfile.professional_experience).map((item, index) => (
                  <InfoBox
                    key={index}
                    data={item}
                    setModelProfile={setModelProfile}
                    indexToModify={index}
                    isSavedChange={handleSaveStateChange}
                    canSelectOnePage={!(!canSelectOnePage && !item.is_one_page)}
                  />
                ))}
              </Wrapper>
            </SectionProfile>

            <SectionProfile title={Text.ProgrammingLanguages} ClickButton={() => setProgrammingSkillsModal(true)}>
              <Tags
                background={backgroundDocument}
                data={tagsMapper(modelProfile.programming_languages)}
                categoryName={programmingLanguages}
                removeItemFunc={(index) => removeSkillFromModelByIndex(index, skillsEnum.programmingLanguages)}
                threshold={TEMPLATE_SECTIONS_THRESHOLD.programmingLanguages}
                isDragDisable={true}
              />
            </SectionProfile>

            <SectionProfile title={Text.DB} ClickButton={() => setDBSkillsModal(true)}>
              <Tags
                background={backgroundDocument}
                data={tagsMapper(modelProfile.databases)}
                categoryName={DBSkills}
                removeItemFunc={(index) => removeSkillFromModelByIndex(index, skillsEnum.databases)}
                threshold={TEMPLATE_SECTIONS_THRESHOLD.databases}
                isDragDisable={true}
              />
            </SectionProfile>

            <SectionProfile title={Text.Frameworks} ClickButton={() => setFrameworksModal(true)}>
              <Tags
                background={backgroundDocument}
                data={tagsMapper(modelProfile.technologies_and_frameworks)}
                removeItemFunc={(index) => removeSkillFromModelByIndex(index, skillsEnum.technologiesAndFrameworks)}
                categoryName={FrameworksAndTechnologies}
                threshold={TEMPLATE_SECTIONS_THRESHOLD.technologies}
                isDragDisable={true}
              />
            </SectionProfile>

            <SectionProfile title={Text.SoftSkills} ClickButton={() => setSoftSkillsModal(true)}>
              <Tags
                background={backgroundDocument}
                data={tagsMapper(modelProfile.soft_skills)}
                removeItemFunc={(index) => removeSkillFromModelByIndex(index, skillsEnum.softSkills)}
                categoryName={SoftSkills}
                isDragDisable={true}
              />
            </SectionProfile>

            <SectionProfile title={Text.Repository} ClickButton={() => setRepositoryModal(true)} pencil={'true'}>
              <p>LinkedIn: {modelProfile.repository?.linkedin_link}</p>
              <p>Github: {modelProfile.repository?.github_link}</p>
            </SectionProfile>

            <SectionProfile title={Text.Hobbies} ClickButton={() => setHobbiesModal(true)}>
              <Tags
                background={backgroundDocument}
                data={tagsMapper(modelProfile.hobbies)}
                removeItemFunc={(index) => removeSkillFromModelByIndex(index, skillsEnum.hobbies)}
                categoryName={Hobbies}
                isDragDisable={true}
                threshold={TEMPLATE_SECTIONS_THRESHOLD.hobbies}
              />
            </SectionProfile>

            <SectionProfile title={Text.Domains} ClickButton={() => setDomainSkillsModal(true)}>
              <Tags
                background={backgroundDocument}
                data={tagsMapper(modelProfile.domains)}
                removeItemFunc={(index) => removeSkillFromModelByIndex(index, skillsEnum.domains)}
                threshold={TEMPLATE_SECTIONS_THRESHOLD.industryVerticals}
                isDragDisable={true}
              />
            </SectionProfile>

            <SectionProfile
              title={Text.TechnicalSkills}
              tooltip={Text.TechnicalSkillsTooltip}
              ClickButton={() => setTechnicalSkillsModal(true)}>
              <Tags
                background={backgroundDocument}
                data={tagsMapper(modelProfile.technical_skills)}
                removeItemFunc={(index) => removeSkillFromModelByIndex(index, skillsEnum.technicalSkills)}
                categoryName={TechnicalSkills}
                threshold={TEMPLATE_SECTIONS_THRESHOLD.technicalSkills}
                isDragDisable={true}
              />
            </SectionProfile>

            <SubmitWrapper>
              <Disclaimer
                weight='normal'
                left='1px'
                text={Email}
                icon={<MailIcon size={20} style={{ marginRight: '10px' }} />}
              />
              {isWaitingSave && (
                <Spinner loadingText='' displaytype='flex' height='20px' direction='row-reverse' right='18px' />
              )}
              <SaveButtonWrapper>
                <Button
                  disabled={isSaved || isWaitingSave}
                  type='primary'
                  onClick={() => onSubmitWithRenew(modelProfile)}>
                  Save
                </Button>
              </SaveButtonWrapper>
              {ErrorRequest.ErrorValue ? <ErrorText>{ErrorRequest.ErrorText}</ErrorText> : undefined}
            </SubmitWrapper>
          </ProfileWrapper>
        </>

        <ModalExperience
          data={dataModel}
          openModal={createModal}
          setOpenModal={setCreateModal}
          setModelProfile={setModelProfile}
          mode={'create'}
          skillName={IndustrySector}
          isSavedChange={handleSaveStateChange}
          canSelectOnePage={canSelectOnePage}
        />

        <ModalLanguages
          open={languagesModal}
          initialState={modelProfile.languages}
          setModal={setLanguagesModal}
          setModelProfile={setModelProfile}
          skillsEnum={skillsEnum}
          isSavedChange={handleSaveStateChange}
          threshold={TEMPLATE_SECTIONS_THRESHOLD.languages}
        />

        <UserDefinedSkill
          open={ProgrammingSkillsModal}
          setModal={setProgrammingSkillsModal}
          setModelProfile={setModelProfile}
          initialState={modelProfile.programming_languages}
          title={<TitleWithTooltipAboutAddingSkills title={Text.ProgrammingLanguages} />}
          subtitle={Text.SkillName}
          mode='programming'
          skillName={programmingLanguages}
          threshold={TEMPLATE_SECTIONS_THRESHOLD.programmingLanguages}
        />

        <UserDefinedSkill
          open={DBSkillsModal}
          setModal={setDBSkillsModal}
          setModelProfile={setModelProfile}
          initialState={modelProfile.databases}
          title={<TitleWithTooltipAboutAddingSkills title={Text.DB} />}
          subtitle={Text.SkillName}
          mode='DB'
          skillName={DBSkills}
          threshold={TEMPLATE_SECTIONS_THRESHOLD.databases}
        />

        <UserDefinedSkill
          open={frameworksModal}
          setModal={setFrameworksModal}
          setModelProfile={setModelProfile}
          initialState={modelProfile.technologies_and_frameworks}
          title={<TitleWithTooltipAboutAddingSkills title={Text.Frameworks} />}
          subtitle={Text.SkillName}
          mode='frameworks'
          skillName={FrameworksAndTechnologies}
          threshold={TEMPLATE_SECTIONS_THRESHOLD.technologies}
        />

        <SkillLevelModal
          open={softSkillsModal}
          setModal={setSoftSkillsModal}
          setModelProfile={setModelProfile}
          initialState={modelProfile.soft_skills}
          title={Text.SoftSkills}
          subtitle={Text.SkillName}
          mode='softSkills'
          skillName={SoftSkills}
          mail={modelProfile.email}
          defaultNavName={Text.Edit}
        />

        <SkillLevelModal
          open={technicalSkillsModal}
          setModal={setTechnicalSkillsModal}
          setModelProfile={setModelProfile}
          initialState={modelProfile.technical_skills}
          title={<TitleWithTooltipAboutAddingSkills title={Text.TechnicalSkills} />}
          subtitle={Text.SkillName}
          mode='technicalSkills'
          skillName={TechnicalSkills}
          mail={modelProfile.email}
          defaultNavName={Text.Edit}
          allowAdd={false}
          showDeleteOption={false}
          applyLevel
          threshold={TEMPLATE_SECTIONS_THRESHOLD.technicalSkills}
        />

        <SkillLevelModal
          open={hobbiesModal}
          setModal={setHobbiesModal}
          setModelProfile={setModelProfile}
          initialState={modelProfile.hobbies}
          title={Text.Hobbies}
          subtitle={Text.SkillName}
          mode='hobbies'
          skillName={Hobbies}
          mail={modelProfile.email}
          defaultNavName={Text.Edit}
          threshold={TEMPLATE_SECTIONS_THRESHOLD.hobbies}
        />

        <RepositoryModal
          open={repositoryModal}
          setModal={setRepositoryModal}
          setModelProfile={setModelProfile}
          title={Text.Repository}
          initialState={modelProfile}
        />

        <ModalSummary
          setSummaryModal={setSummaryModal}
          visible={summaryModal}
          title={Text.Summary}
          initialState={modelProfile}
          setModelProfile={setModelProfile}
          isSavedChange={handleSaveStateChange}
        />

        <ModalEducationalBackground
          open={educationalBackGroundsModal}
          title={Text.Education}
          allowAdd={true}
          initialFormValues={{
            institute: '',
            grade: '',
            status: '',
            end_date: 'In Progress'
          }}
          skillName={EducationGrades}
          fields={[
            {
              label: 'Educational Institution',
              name: 'institute',
              type: 'text'
            },
            {
              label: 'Degree',
              name: 'grade',
              type: 'autocomplete'
            },
            {
              label: 'Status',
              name: 'status',
              type: 'select',
              options: [
                { label: 'Finished', value: 'finished' },
                { label: 'Not Finished', value: 'not finished' }
              ]
            },
            {
              label: 'End Date',
              name: 'end_date',
              type: 'date'
            }
          ]}
          setModal={setEducationalBackGroundsModal}
          setModelProfile={setModelProfile}
          mode={skillsEnum.educationalBackground}
          skillsEnum={skillsEnum}
          selectedTag={selectedEducationalBackGroundTag}
        />

        <ModalEducationalBackground
          open={certificationsModal}
          title={Text.Certifications}
          allowAdd={true}
          initialFormValues={{
            certifying_entity: '',
            name: '',
            status: '',
            retriever_date: 'In Progress'
          }}
          skillName={CertificationEntity}
          fields={[
            {
              label: 'Certification Title',
              name: 'name',
              type: 'text'
            },
            {
              label: 'Certifying Entity',
              name: 'certifying_entity',
              type: 'autocomplete'
            },
            {
              label: 'Status',
              name: 'status',
              type: 'select',
              options: [
                { label: 'Finished', value: 'finished' },
                { label: 'Not Finished', value: 'not finished' }
              ]
            },
            {
              label: 'End Date',
              name: 'retriever_date',
              type: 'date'
            }
          ]}
          setModal={setCertificationsModal}
          setModelProfile={setModelProfile}
          mode={skillsEnum.certification}
          skillsEnum={skillsEnum}
          selectedTag={selectedCertificationTag}
        />

        <UserDefinedSkill
          open={DomainSkillsModal}
          setModal={setDomainSkillsModal}
          setModelProfile={setModelProfile}
          initialState={modelProfile.domains}
          title={Text.Domains}
          subtitle={Text.SkillName}
          mode='domains'
          skillName={Domains}
          threshold={TEMPLATE_SECTIONS_THRESHOLD.industryVerticals}
        />
      </BeforeUnloadHandler>
    </>
  )
}

EditProfile.propTypes = {
  route: PropTypes.object,
  navigation: PropTypes.object,
  hideEditButton: PropTypes.bool,
  hideHeaderMenu: PropTypes.bool
}
